import RADApplication from '@/Management/RADApplication';
import EventHelper from '@/Utility/EventHelper';

export function openDownloadDialogFor(url: string) {
    url = parseUrl(url);

    let iframe = $('<iframe>').hide().attr('src', url).appendTo('body');
        
    iframe.ready(() => {
        window.setTimeout(() => {
            iframe.remove();
        }, 3 * 60 * 1000);
    });
}
    
export async function fetchBlobFromApplicationAsync(url: string): Promise<[Blob, string | undefined]> {
    url = parseUrl(url);
    return await fetch(url, {
        method: 'GET',
        headers: {
            token: RADApplication.getInstance().token
        }
    }).then(async (response: Response) => {
        if (!response.ok) {
            throw new Error(`Failed to download file: ${response.statusText}`);
        }
            
        const contentDisposition = response.headers.get("Content-Disposition");
        const blob = await response.blob();
        const filename = parseFilenameFromContentDisposition(contentDisposition);
        return [blob, filename];
    });
}
    
export function openDownloadDialogFromApplicationAsync(url: string) {
    return fetchBlobFromApplicationAsync(url).then(([blob, filename]) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        try {
            openDownloadDialog(downloadUrl, filename);
        } finally {
            window.URL.revokeObjectURL(downloadUrl);
        }
    }).catch(reason => {
        console.error('Error downloading file:', reason);
    })
}

//Use of the Content-Disposition Header Field in the Hypertext Transfer Protocol (HTTP)
//https://datatracker.ietf.org/doc/html/rfc6266
function parseFilenameFromContentDisposition(contentDisposition: string): string | undefined {
    if (!contentDisposition) {
        return undefined;
    }
        
    const parts = contentDisposition.split(';').map(part => part.trim());
    //Prüfe zuerst nach UTF-8 Dateiname (filename*=)
    for (const part of parts) {
        const match = part.match(/filename\*\s*=\s*(?:UTF-8'')?(.+)/i);
        if (match && match[1]) {
            return decodeURIComponent(match[1]);
        }
    }
        
    //Prüfe nun nach filename=
    for (const part of parts) {
        let match = part.match(/filename\s*=\s*"?(.+)"?/i);
        if (match && match[1]) {
            return decodeURIComponent(match[1]);
        }
    }

    return undefined;
}

export function parseUrl(url: string): string {
    if (!url) {
        return '';
    }

    url = url.replace('$$TEMPLATE_HANDLER$$', RADApplication.getInstance().radEnvironmentTemplateHandler);
    url = url.replace('$$DATA_HANDLER$$', RADApplication.getInstance().radEnvironmentDataHandler);
    url = url.replace('$$MEDIUM_HANDLER$$', RADApplication.getInstance().radEnvironmentMediumHandler);

    return url;
}
    
export function openDownloadDialog(href: string, filename: string | null | undefined): void {
    const a = document.createElement('a');
    a.href = href;
        
    if (filename === undefined)
        filename = "download"
        
    a.download = filename;
    a.target = 'blank';
    a.style.display = "none";

    document.body.appendChild(a);

    // Important, otherwise the click is catched in a global event listener and would not start the download
    EventHelper.ignoreRADEventHandlers(a);
        
    a.click();
    a.remove();
}

export function openDownloadDialogForInlineFile(content: string, filename: string): void {
    openDownloadDialog('data:text/plain;charset=utf-8,' + encodeURIComponent(content), filename)
}

export default {
    openDownloadDialogForInlineFile,
    openDownloadDialog,
    parseUrl,
    openDownloadDialogFromApplicationAsync,
    fetchBlobFromApplicationAsync,
    openDownloadDialogFor
}